<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="技师号码">
          <el-input size="small" v-model="searchForm.phone_no" placeholder="请输入技师号码"></el-input>
        </el-form-item>
        <el-form-item label="用户号码">
          <el-input size="small" v-model="searchForm.peer_no" placeholder="请输入用户号码"></el-input>
        </el-form-item>
        <el-form-item label="隐私号码">
          <el-input size="small" v-model="searchForm.secret_no" placeholder="请输入隐私号码"></el-input>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <!-- <el-date-picker size="small" v-model="searchForm.createTime" type="datetimerange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker> -->
            <el-date-picker v-model="searchForm.createTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <!-- <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加音乐</el-button> -->
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <el-table-column type="index" :index="1" prop="" align="center" label="序号" width="50"></el-table-column>
          <!-- <el-table-column prop="" label="号码" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.call_type==0">
                主叫号码：{{scope.row.phone_no}} </br>
                被叫号码：{{scope.row.peer_no}}</br>
                隐私号码：{{scope.row.peer_no}}
              </div>
              <div v-if="scope.row.call_type==1">
                主叫号码：{{scope.row.peer_no}} </br>
                被叫号码：{{scope.row.phone_no}}</br>
                {{scope.row.secret_no}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="主叫号码" align="center" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.call_type==0">
                {{scope.row.phone_no}}
              </div>
              <div v-if="scope.row.call_type==1">
                {{scope.row.peer_no}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="被叫号码" align="center" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.call_type==0">
                {{scope.row.peer_no}}
              </div>
              <div v-if="scope.row.call_type==1">
                {{scope.row.phone_no}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="secret_no" align="center" label="隐私号码"></el-table-column>
          <el-table-column prop="call_time" align="center" label="呼叫发起时间"></el-table-column>
          <el-table-column prop="start_time" align="center" label="呼叫接听时间"></el-table-column>
          <el-table-column prop="unconnected_cause" align="center" label="未接通通话的原因">
            <template slot-scope="scope">
              <span v-if="scope.row.unconnected_cause==0">正常通话</span>
              <span v-else-if="scope.row.unconnected_cause==1">黑名单拦截</span>
              <span v-else-if="scope.row.unconnected_cause==2">无绑定关系</span>
              <span v-else-if="scope.row.unconnected_cause==3">呼叫限制</span>
              <span v-else>其他</span>
            </template>
          </el-table-column>
          <el-table-column prop="pool_key" align="center" label="号码池"></el-table-column>
          <el-table-column prop="release_time" align="center" label="呼叫挂断时间"></el-table-column>
          <el-table-column prop="call_type" align="center" label="呼叫发起时间"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="record_url" label="通话录音地址"></el-table-column>
          <el-table-column prop="city" align="center" label="隐私号码所属地域"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="160">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button @click="downloadClick(scope.row)" type="primary" size="small">下载</el-button>
                <el-button @click="bofangClick(scope.row)" type="primary" size="small">播放</el-button>
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑音乐</el-button>
                <el-button @click="delClick(scope.row)" type="text" size="small">删除音乐</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import MusicApi from "@/api/music.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      createTime: "",
      searchForm: {
        secret_no: "",
        peer_no: "",
        secret_no: ""
      }
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.start_time = self.createTime[0];
      Params.end_time = self.createTime[1];
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      MusicApi.calllist(Params, true)
        .then(data => {
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      console.log(row, "编辑技师");
      this.$router.push({
        path: "/music/callmanage/edit",
        query: {
          music_id: row.music_id,
          scene: "edit"
        }
      });
    },
    downloadClick(row) {
      MusicApi.getcallUrl({
        id: row.id
      })
        .then(data => {
          // 创建一个下载链接
          // const url = window.URL.createObjectURL(new Blob([data.data]));
          const url = data.data;
          const link = document.createElement("a");
          link.href = url;
          document.body.appendChild(link);
          link.setAttribute("download", "录音.mp3"); // 设置下载的文件名
          link.click();
          // 释放URL对象
          window.URL.revokeObjectURL(url);
          // 移除下载链接
          document.body.removeChild(link);
        })
        .catch(error => {
          self.$message({
            message: "下载失败",
            type: "error"
          });
        });
    },
    bofangClick(row) {
      MusicApi.getcallUrl({
        id: row.id
      })
        .then(data => {
          const audio = new Audio(data.data);
          audio.play();
        })
        .catch(error => {
          self.$message({
            message: "播放失败",
            type: "error"
          });
        });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          MusicApi.Musicdelete({
            music_id: row.music_id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/music/callmanage/index.vue